const ResendInvitation = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="22"
      viewBox="0 0 16 22"
    >
      <path
        data-name="Caminho 12359"
        d="M12 6v3l4-4-4-4v3a7.986 7.986 0 0 0-6.76 12.26L6.7 14.8A5.87 5.87 0 0 1 6 12a6 6 0 0 1 6-6zm6.76 1.74L17.3 9.2A5.99 5.99 0 0 1 12 18v-3l-4 4 4 4v-3a7.986 7.986 0 0 0 6.76-12.26z"
        transform="translate(-4 -1)"
      />
    </svg>
  );
};

export default ResendInvitation;
